// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1OIqT","content":"styles_content__1Fwy6","selectAll":"styles_selectAll__1rvh6"};